import React, { createContext } from 'react';
import { node } from 'prop-types';

import { useRentalConsumables } from '../hooks/useRentalConsumables';
import { GET_RENTAL_CONSUMABLES_QUERY } from '../utils/queries';

export const defaultContext = {
  data: null,
  loading: false,
  error: '',
  executeRequest: async () => {}
};

export const GetRentalConsumablesContext = createContext(defaultContext);

const GetRentalConsumablesProvider = ({ children }) => {

  return (
    <GetRentalConsumablesContext.Provider
      value={{ ...useRentalConsumables() }}
    >
      {children}
    </GetRentalConsumablesContext.Provider>
  );
};

GetRentalConsumablesProvider.propTypes = {
  children: node.isRequired
};

GetRentalConsumablesProvider.dataModel = GET_RENTAL_CONSUMABLES_QUERY;

export default GetRentalConsumablesProvider;
